/**
 * カレンダー連携スコープ不足時のエラーハンドラ
 * 403発生時にモーダル表示用イベントを初回だけ発火する
 */
export const CALENDAR_SCOPE_ERROR_EVENT = 'calendar-scope-permission-missing';

let hasNotifiedScopeError = false;

export const notifyCalendarScopeError = () => {
    if (typeof window === 'undefined') return;
    if (hasNotifiedScopeError) return;
    hasNotifiedScopeError = true;
    window.dispatchEvent(new CustomEvent(CALENDAR_SCOPE_ERROR_EVENT));
};
